import React, { Component } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import { EditButton, ViewButton, DeleteButton } from '../output/CrudButton';
import { classNames } from '../../functions/classNames';
import './CollapsibleRow.css';

class CollapsibleRow extends Component {
  toggle = () => {
    this.props.toggleOpen(this.props.resource.uuid);
  };

  render() {
    const { open, label, children, resource, updateResults,
              toggleModal, hideEditButton, hideViewButton, showDeleteButton,
              handleRemove, entityRoute, className, } = this.props;

    const childrenWithProps = React.Children.map(children,
      child => React.cloneElement(child, {
                  resource: resource,
                  updateResults: updateResults,
                  toggleModal: toggleModal,
                })
    );

    return (
      <div className={classNames('CollapsibleRow', className, (open ? 'open' : 'collapsed'))} >
        <div className="container">
          <div className="title">
            <div className="row-label" onClick={this.toggle}>{label}</div>
            <div className="button-container">
              {hideEditButton ? '' :
                <EditButton resource={resource} entityRoute={entityRoute} />
              }
              {hideViewButton ? '' :
                <ViewButton resource={resource} entityRoute={entityRoute} />
              }
              {showDeleteButton ?
                <DeleteButton resource={resource} handleRemove={handleRemove} /> : ''
              }
              <span className="toggle-button" onClick={this.toggle}>
                {open ? <ChevronUp /> : <ChevronDown />}
              </span>
            </div>
          </div>
          {open ? <div className="content">{childrenWithProps}</div> : ''}
        </div>
      </div>
    );
  }
}

class CollapsibleRowList extends Component {
  constructor(props) {
    super(props);

    const saved = localStorage.getItem('open-elements');
    const openItems = saved ? JSON.parse(saved) : [];
    const items = this.purge(openItems, props.data);
    this.state = { openItems: items };
  }

  componentWillUnmount = () => {
    const { openItems } = this.state;
    const items = this.purge(openItems, this.props.data);
    localStorage.setItem('open-elements', JSON.stringify(items));
  };

  purge = (items, data) => {
    const uuids = data.map(d => d.uuid);
    return items.filter(u => uuids.indexOf(u) >= 0);
  };

  toggleOpen = (row) => {
    const { openItems } = this.state;

    const idx = openItems.indexOf(row);
    if (idx > -1) {
      delete openItems[idx];
    } else {
      openItems.push(row);
    }

    this.setState({ openItems: openItems });
  };

  getName = (d, n) => {
    if (Array.isArray(n)) {
      return n.map(i => d[i]).join(' - ');
    } else {
      return d[n];
    }
  };

  render() {
    const { data, optionLabelName, rowMarker, children, ...other } = this.props;
    const { openItems } = this.state;

    return (
      <div className="CollapsibleRowList">
        {data.map((d, i) =>
          <CollapsibleRow {...other}
            key={i}
            resource={d}
            label={this.getName(d, optionLabelName)}
            className={rowMarker ? rowMarker(d) : ''}
            open={openItems.indexOf(d.uuid) >= 0}
            toggleOpen={this.toggleOpen}
          >
            {children}
          </CollapsibleRow>)
        }
      </div>
    );
  }

}

export default CollapsibleRowList;



// WEBPACK FOOTER //
// ./src/main/components/container/CollapsibleRow.js